<template>
    <div class="pets-slider">
        <Swiper
            :modules="[Navigation]"
            slides-per-view="auto"
            :navigation="{nextEl: '._next', prevEl: '._prev', disabledClass: '_disabled'}"
        >
            <SwiperSlide v-for="(slide, idx) in petsData" :key="idx">
                <div class="pets-slider__item">
                    <a
                        class="pets-slider__item-photo"
                        :href="`https://www.friendforpet.ru/pet/${slide.pet_id}`"
                    >
                        <PetsPhotoSlider
                            :photos="slide.pet_photo.split(', ').slice(0, 3)"
                        />
                    </a>
                    <div class="pets-slider__item-info">
                        <a :href="`https://www.friendforpet.ru/pet/${slide.pet_id}`" class="pets-slider__item-name">
                            {{ slide.pet_name }}
                        </a>
                        <p>
                            <span v-if="slide.pet_age > 0">
                                {{ getYearString(slide.pet_age) }}
                            </span>
                            <span v-if="slide.pet_month_age > 0">
                                {{ getMonthString(slide.pet_month_age) }}
                            </span>,
                            {{ slide.pet_sex }}
                            <br>
                            {{ slide.pet_city }}
                        </p>
                    </div>
                </div>
            </SwiperSlide>
        </Swiper>
        <div class="pets-slider__nav">
            <span class="pets-slider__nav-btn _prev">
                <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 17.4414L1 9.44134L9 1.44141" stroke="#ED1C25" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
            <span class="pets-slider__nav-btn _next">
                <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 17.4414L9 9.44134L1 1.44141" stroke="#ED1C25" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import PetsPhotoSlider from './PetsPhotoSlider.vue';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const petsData = ref(null);

async function fetchData() {
    await fetch('https://www.friendforpet.ru/api/pets')
        .then(response => {
            return response.json();
        })
        .then(data => {
            petsData.value = data.search_results;
        })
        .catch(error => {
            console.error('Error:', error);
        });
}

onMounted(() => {
    fetchData();
});

const getYearString = (year) => {
    return year === 1 ? `${year} год` : (year >= 2 && year <= 4) ? `${year} годa` :  year >= 5 ? `${year} лет` : null;
};

const getMonthString = (month) => {
    return month === 1 ? ` ${month} месяц` : (month >= 2 && month <= 4) ? ` ${month} месяца` :  month >= 5 ? ` ${month} месяцев` : null;
};
</script>
